module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "types"
  }, [_c('h2', [_vm._v("Types")]), _vm._v(" "), _c('h3', [_vm._v("Label")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('mt-input', {
    attrs: {
      "name": "with-label",
      "placeholder": "Enter your details here",
      "label": "Field label"
    }
  })], 1), _vm._v(" "), _c('h3', [_vm._v("Caption")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('mt-input', {
    attrs: {
      "name": "with-caption",
      "placeholder": "Enter your details here",
      "label": "Field label",
      "caption": "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "style"
  }, [_c('h2', [_vm._v("Style")]), _vm._v(" "), _c('h3', [_vm._v("Colors")]), _vm._v(" "), _c('div', {
    staticClass: "left mt--bg--neutrals-light-gray-01 "
  }, [_c('img', {
    attrs: {
      "src": _vm.colors,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('h3', [_vm._v("Sizing")]), _vm._v(" "), _c('div', {
    staticClass: "left mt--bg--neutrals-light-gray-01 "
  }, [_c('img', {
    attrs: {
      "src": _vm.sizing,
      "alt": ""
    }
  })]), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('div', {
    staticClass: "mt--clearfix"
  }), _vm._v(" "), _c('h2', [_vm._v("States")]), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": _vm.statesNormal
    }
  })]), _vm._v(" "), _vm._m(3, false, false), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": _vm.statesHover
    }
  })]), _vm._v(" "), _vm._m(4, false, false), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": _vm.statesFocus
    }
  })]), _vm._v(" "), _vm._m(5, false, false), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": _vm.statesType
    }
  })]), _vm._v(" "), _vm._m(6, false, false), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": _vm.statesValid
    }
  })]), _vm._v(" "), _vm._m(7, false, false), _vm._v(" "), _c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": _vm.statesInvalid
    }
  })]), _vm._v(" "), _vm._m(8, false, false)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "header-wrapper"
    }
  }, [_c('div', {
    staticClass: "header"
  }, [_c('h1', [_vm._v("Text input")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Text: #485464  opacity: 30%")]), _vm._v(" "), _c('p', [_vm._v("Label text: #485464")]), _vm._v(" "), _c('p', [_vm._v("Caption text: #718091")]), _vm._v(" "), _c('p', [_vm._v("Border: #B2C0D0")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Corner radius: 2px")]), _vm._v(" "), _c('p', [_vm._v("Width: auto")]), _vm._v(" "), _c('p', [_vm._v("Height: 36px")]), _vm._v(" "), _c('p', [_vm._v("Border: 1px")]), _vm._v(" "), _c('p', [_vm._v("Font size: 14px (Line height: 22px)")]), _vm._v(" "), _c('p', [_vm._v("Label font size: 12px (Line height: 20px)")]), _vm._v(" "), _c('p', [_vm._v("Caption font size: 11px (Line height: 14px)")]), _vm._v(" "), _c('p', [_vm._v("Horizontal padding: 8px")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Border: #B2C0D0")]), _vm._v(" "), _c('p', [_vm._v("Text: #485464  opacity 30%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Border: #718091")]), _vm._v(" "), _c('p', [_vm._v("Text: #485464  opacity 30%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Border: #097DB7")]), _vm._v(" "), _c('p', [_vm._v("Text: #485464  opacity 30%")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Border: #097DB7")]), _vm._v(" "), _c('p', [_vm._v("Text: #171B20")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Border: #B2C0D0")]), _vm._v(" "), _c('p', [_vm._v("Text: #171B20")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right mt-font--body10"
  }, [_c('p', [_vm._v("Border: #B2C0D0")]), _vm._v(" "), _c('p', [_vm._v("Text: #171B20")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ea489b2","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Input.vue
// module id = QfzT
// module chunks = 0